<template>
    <div class="bottom">
        <div class="left animate__animated  animate__slow" v-if="isLoaded" v-appear="'animate__fadeInUp'">
            <div class="title">▏{{ $t('footer.contact') }}</div>
            <div class="logo" v-if="config && config.logo">
<!--                <img src="http://japanjukiadmin.sewworld.com/upload/2025/03/26/303980453_20250326181900a020.png" alt="logo" class="img">-->
              <img :src="config.logo" alt="logo" class="img">
            </div>
            <div class="content" v-if="config">
                <div class="text fontSize14">
                    {{ $t('footer.phone') }}：{{ config.landlineNumber}}
                </div>
                <div class="text fontSize14">
                    {{ $t('footer.mobile') }}：{{ config.tel}}
                </div>
                <div class="text fontSize14">
                    {{ $t('footer.time') }}：{{ config.email}}
                </div>
                <div class="text fontSize14">
                    {{ $t('footer.address') }}：{{ language == 'zh' ? config.corporateAddress : config.enCorporateAddress}}
                </div>
            </div>
            <div class="copyright" v-if="config">
                <div class="text fontSize14">
                    {{ $t('footer.name') }}：{{ language == 'zh' ? config.corporateName : config.enCorporateName}}
                </div>
                <div v-dompurify-html="config.icpRecord" class="text fontSize14"></div>
            </div>
        </div>
        <div class="right animate__animated  animate__slow" ref="message" v-if="isLoaded" v-appear="'animate__fadeInRight'">
            <div class="title fontSize16">{{ $t('message.leave') }}</div>
            <div class="content">
                <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="80px" class="demo-ruleForm">
                    <el-form-item :label="$t('message.title')" prop="title">
                        <el-input v-model="formData.title"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('message.contacts')" prop="contacts">
                        <el-input v-model="formData.contacts"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('message.phone')" prop="phone">
                        <el-input v-model="formData.phone"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('message.email')" prop="email">
                        <el-input v-model="formData.email"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('message.corporateName')" prop="corporateName">
                        <el-input v-model="formData.corporateName"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('message.corporateAddress')" prop="corporateAddress">
                        <el-input v-model="formData.corporateAddress"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('message.content')" prop="content">
                        <el-input v-model="formData.content"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <el-button type="primary" class="btn fontSize14" @click="submitForm('ruleForm')" v-preventReClick>{{ $t('footer.contact') }}</el-button>
            <!-- <div class="btn" @click="submitForm('ruleForm')" v-preventReClick> {{ $t('footer.contact') }}</div> -->
        </div>
    </div>
</template>

<script>
import {
    addMessageBoard
} from '@/api/index'
export default {
    props: {
        config: {
            typeof: Object,
            default: {}
        },

        language: {
            typeof: String,
            default: 'zh'
        },
    },
    components: {
    },
    data() {
        var validatePhone = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入手机号'));
            } else {
                const test = /^(13[0-9]|14[5|7|9]|15[0-3|5-9]|16[2|5|6|7]|17[0-8]|18[0-9]|19[8|9])\d{8}$/.test(value)
                if (!test) {
                    callback(new Error('请输入正确格式的手机号'));
                } else {
                    callback();
                }
            }
        };
        var validateEmail = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入邮箱'));
            } else {
                const test = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
                if (!test) {
                    callback(new Error('请输入正确格式的邮箱'));
                } else {
                    callback();
                }
            }
        };
        return {
            isLoaded:false,
            input: '',
            formData: {
                title: '',//标题
                contacts: '',//
                phone: '',
                email: "",
                corporateName: '',
                corporateAddress: '',
                content: '',
                typeId: 140,//归属栏目id
            },
            rules: {
                title: [
                    { required: true, message: '请输入留言标题', trigger: 'blur' },
                ],
                contacts: [
                    { required: true, message: '请输入联系人', trigger: 'blur' },
                ],
                phone: [
                    { validator: validatePhone, trigger: 'blur' },
                ],
                email: [
                    { validator: validateEmail, trigger: 'blur' },
                ],
                corporateName: [
                    { required: true, message: '请输入公司名称', trigger: 'blur' },
                ],
                corporateAddress: [
                    { required: true, message: '请输入公司地址', trigger: 'blur' },
                ],
                content: [
                    { required: true, message: '请输入留言内容', trigger: 'blur' },
                ],

            }
        }
    },
    watch: {
    },
    computed: {
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.addMessageBoard()
                } else {
                    return false;
                }
            });
        },
        async addMessageBoard() {
            let that = this
            that.formData.lang = that.$store.state.language == 'zh' ? 'cn' : 'en'
            const info = await addMessageBoard(that.formData)
            if (info && info.code == 200) {
                that.$message('留言成功！');
            }
        },
    },
    created() {
      console.log("this.config",this.config)
    },
    mounted() {
        this.isLoaded = true
    }
}
</script>

<style scoped lang="scss">
.bottom {
    width: 100%;
    height: 45.4286rem;
    background-image: url('http://japanjukiadmin.jukicc.com/upload/2025/04/29/850747004_20241029171439a020.png');
    /* 设置图片路径 */
    background-size: cover;
    /* 背景图片覆盖整个元素 */
    background-repeat: no-repeat;
    /* 背景图片不重复 */
    background-position: center;
    /* 背景图片居中 */
    padding: 6.1429rem 10vw 4.5714rem;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
    .left {
        color: #FFFFFF;

        .title {
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 1.8571rem;
        }

        .logo {
            display: flex;
            align-items: center;
            margin: 8.4286rem 0 4.5714rem;

            .img {
                height: 2.1429rem;
                width: auto;
            }

            .name {
                margin-left: .8571rem;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #FFFFFF;
            }
        }

        .content {
            .text {
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 2.5714rem;
                opacity: 0.5;
            }
        }

        .copyright {
            margin-top: 42px;

            .text {
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #FFFFFF;
            }
        }
    }

    .right {
        margin-left: 1.1429rem;
        width: 48.8571rem;
        height: 35.4286rem;
        background: #FFFFFF;
        padding: 2.1429rem 5.7143rem 2.1429rem;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .title {
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #000000;
            line-height: 2.2857rem;
            opacity: 0.8;
        }

        .content {
            width: 70%;
            margin: 0 auto;
            display: flex;
            flex-direction: column;
            align-items: flex-end;


            .demo-ruleForm{
                width: 100%;
            }
        }

        .btn {
            margin: 0 auto;
          margin-top: 0.5rem;
            width: 9.8571rem;
            height: 2.7143rem;
            line-height: 0.5714rem;
            border: 1px solid #7FCCA1;
            // line-height: 2.5714rem;
            text-align: center;
            font-family: Microsoft YaHei;
            font-weight: 400;
            //font-size: 1.1429rem;
            color: #7FCCA1;
        }
    }
}

::v-deep .el-form-item__label {
    white-space: nowrap;
    color: #C1C1C1;
}

::v-deep .el-form-item {
    margin-bottom: 10px;
}

::v-deep .el-input__inner {
    border-radius: 0;
    border: none;
    border-bottom: 1px solid #C1C1C1;
    // width: 21rem;
    height: 1.7143rem;
    line-height: 1.7143rem;
}

::v-deep .el-button--primary{
    background-color: #FFFFFF;
    span{
        color: #7FCCA1;
    }
}
::v-deep .el-button--primary:hover{
    background-color: #FFFFFF;
}

@media screen and (max-width: 1200px) {
  .btn{
    margin-top: 0.5rem;
    width: 7.8571rem;
    height: 2rem;
  }
  ::v-deep .el-form-item__label {
    font-size: 1rem;
    margin-left: -1rem;
  }

  ::v-deep .el-form-item:nth-child(n+1) {
    margin-top: 2rem;
  }

  ::v-deep .el-input input{
    height: 1.2rem;
  }
    .bottom {
        border-top: 1px solid #EEEEEE;
        flex-direction: column-reverse;
        height: auto;
        padding: 0 0 20px;
        box-sizing: border-box;
        .left{
            .logo{
                margin: 1.4286rem 0;
            }

            .copyright{
                margin-top: 1.4286rem;
            }
        }

        .right {
            margin-left: 0;
            width: 100%;
            height: auto;
            padding: 1rem;
            box-sizing: border-box;
            margin-bottom: 20px;
        }
    }
}
</style>
